import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import dayjs from "dayjs";

const Index = (props: any) => {
  const { config } = props;
  const SecondRef = useRef<any>(null);
  const MinuteRef = useRef<any>(null);
  const HoursRef = useRef<any>(null);
  const [Time, setTime] = useState<any>(null);
  const hoursLine = [12, 1, 2, 3, 4, 5 ,6 ,7 ,8 ,9 ,10 ,11];
  const secondLine = Array.from({ length: 60 });
  const [Ratio, setRatio] = useState(1);
  const [Format, setFormat] = useState("h:mm A");
  
  let timer: NodeJS.Timeout;

  useEffect(() => {
    const width = config.data.width < config.data.data.minWidth? config.data.data.minWidth : config.data.width;
    const height = config.data.height < config.data.data.minHeight? config.data.data.minHeight : config.data.height;
    setRatio(width / height);
  }, [props]);

  useEffect(() => {
    
  }, [Ratio]);

  useEffect(() => {
    if (SecondRef.current && MinuteRef.current && HoursRef.current) {
      const startLogoutTimer = () => {
        timer = setInterval(() => {
          let format: any;
          const d = new Date();
          const Second = d.getSeconds();
          const Minute = d.getMinutes();
          const Hours = d.getHours();
          SecondRef.current.style.transform = `rotateZ(${Second * 6}deg)`;
          MinuteRef.current.style.transform = `rotateZ(${Minute * 6}deg)`;
          HoursRef.current.style.transform = `rotateZ(${Hours * 30 + (Minute / 2)}deg)`;
          setTime(() => dayjs(d));
        }, 1000);
      };
    
      startLogoutTimer();
    }
  }, [SecondRef, MinuteRef, HoursRef]);

  useEffect(() => {
    if (config.data.data.time12HourFormat) {
      setFormat("h:mm A");
    } else if (config.data.data.time24HourFormat) {
      setFormat("HH:mm");
    }
  }, [ config.data.data?.time12HourFormat, config.data.data?.time24HourFormat]);

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="componentCore " style={{ height: '100%', width: '100%', position: 'absolute' }}>
        <div id="clockBox" className="clockBox overflow-hidden">
          <div id="clockBody" className={`clockBody ${ (Ratio > 1.1)? "hideThis" : "" }`} style={{ transform: `scale(${Ratio <= 1.1? (Ratio * 1.25) : Ratio})` }}>
            <div id="clock" className="clock">
              <div className="point"></div>
            </div>
            <div className="niddles niddlesS" ref={SecondRef}>
              <i></i>
            </div>
            <div className="niddles niddlesM" ref={MinuteRef}>
              <i></i>
            </div>
            <div className="niddles niddlesH" ref={HoursRef}>
              <i></i>
            </div>
            {hoursLine.map((item: any, index: number) => (
              <span className="text" key={index} style={{ transform: `rotate(calc(30deg * ${index})) ` }}>
                <b style={{ transform: `rotate(calc(-30deg * ${index}))` }}>{item}</b>
              </span>
            ))}
            <div className="clockLine">
              {secondLine.map((item: any, index: number) => (
                <span className="line" key={index} style={{ transform: `rotate(${ 6 * index }deg)` }}>
                  <b></b>
                </span>
              ))}
            </div>
          </div>
          <div className={`clockTime ${ (Ratio > 0.8) && (Ratio < 1.1)? "hideThis" : "" }`} data-ratio={Ratio} style={{ transform: `scale(${Ratio > 1.1? (Ratio + (Ratio / 1.2)) : (Ratio * 1.5)})` }}>
            {dayjs(Time).format(Format)}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(Index);